import { Component, Input, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService, User } from '../../../services/auth.service';
import { UsersService } from '../../../services/users.service';
import { PermissionService, ModuleGroup } from '../../../services/permission.service';
import { NotificationsService, Notification } from '../../../services/notifications.service';
import { ItensMenus, SubItensMenus } from './side-menu-components/itens-menus.interface';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css']
})
export class SideMenuComponent implements OnInit, OnDestroy, AfterViewInit {
  currentUserName: string = '';
  userAvatar: string | null = null;

  // Notificações
  showNotifications: boolean = false;
  notifications: Notification[] = [];
  unreadNotificationsCount: number = 0;

  @Input() itensMenus: ItensMenus[] = [
    {
      name: 'Home',
      icon: 'fa-solid fa-house',
      route: '/dashboard',
      // Home não requer permissão
    },
    {
      name: 'Solicitação de Compras',
      icon: 'fa-solid fa-cart-shopping',
      route: '/purchase-requests',
      groupId: ModuleGroup.SolicitacaoCompras,
      children: [
        {
          name: 'Lista de Solicitações',
          route: '/purchase-requests'
        },
        {
          name: 'Nova Solicitação',
          route: '/purchase-requests/new'
        }
      ]
    },
    {
      name: 'Configuração de preços para aprovação',
      icon: 'fa-solid fa-layer-group',
      route: '/price-approval/ranges',
      groupId: ModuleGroup.Compras,
      children: [
        {
          name: 'Lista de Faixas',
          route: '/price-approval/ranges'
        },
        {
          name: 'Nova Faixa',
          route: '/price-approval/ranges/new'
        }
      ]
    },
    {
      name: 'Comercial',
      icon: 'fa-solid fa-handshake',
      route: '/commercial/customers',
      groupId: ModuleGroup.Commercial,
      children: [
        {
          name: 'Clientes',
          route: '/commercial/customers',
          children: [
            {
              name: 'Lista de Clientes',
              route: '/commercial/customers'
            },
            {
              name: 'Cadastro de Clientes',
              route: '/commercial/customers/new'
            }
          ]
        },

        // {
        //   name: 'Locações',
        //   route: '/commercial/vehicle-rentals',
        //   children: [
        //    {
        //     name: 'Lista de Locações',
        //      route: '/commercial/vehicle-rentals'
        //   },
        //   {
        //     name: 'Nova Locação',
        //     route: '/commercial/vehicle-rentals/new'
        //   }
        //  ]
        // },
        {
          name: 'Locações',
          route: '/contracts',
          children: [
            {
              name: 'Lista de Locações',
              route: '/contracts'
            },
            {
              name: 'Nova Locação',
              route: '/contracts/new'
            }
          ]
        },
        {
          name: 'Agendamentos',
          route: '/appointments',
          queryParams: { groupId: ModuleGroup.Commercial }
        },
        {
          name: 'Aplicativo Loca9',
          route: '/commercial/loca9-app'
        }
      ]
    },
    {
      name: 'Recursos Humanos',
      icon: 'fa-solid fa-id-card',
      route: '/hr/staff',
      groupId: ModuleGroup.RecursosHumanos,
      children: [
        {
          name: 'Funcionários',
          route: '/hr/staff',
          children: [
            {
              name: 'Lista de Funcionários',
              route: '/hr/staff'
            },
            {
              name: 'Cadastro de Funcionários',
              route: '/hr/staff/new'
            }
          ]
        },
        {
          name: 'Departamentos',
          route: '/hr/departments',
          children: [
            {
              name: 'Lista de Departamentos',
              route: '/hr/departments'
            },
            {
              name: 'Novo Departamento',
              route: '/hr/departments/new'
            }
          ]
        },
        {
          name: 'Central de Salários',
          route: '/hr/payroll'
        }
      ]
    },
    {
      name: 'Veículos',
      icon: 'fa-solid fa-car',
      route: '/fleet/vehicles',
      groupId: ModuleGroup.Veiculos,
      children: [
        {
          name: 'Lista de Veículos',
          route: '/fleet/vehicles'
        },
        {
          name: 'Cadastro de Veículos',
          route: '/fleet/vehicles/new'
        },
        {
          name: 'Multas de Trânsito',
          route: '/financial/traffic-fines',
          children: [
            { name: 'Lista de Multas', route: '/financial/traffic-fines' },
            { name: 'Dashboard', route: '/financial/traffic-fines/dashboard' }
          ]
        }
      ]
    },
    {
      name: 'Compras',
      icon: 'fa-solid fa-truck-fast',
      route: '/purchasing/suppliers',
      groupId: ModuleGroup.Compras,
      children: [
        {
          name: 'Fornecedores',
          route: '/purchasing/suppliers',
          children: [
            {
              name: 'Lista de Fornecedores',
              route: '/purchasing/suppliers'
            },
            {
              name: 'Cadastro de Fornecedores',
              route: '/purchasing/suppliers/new'
            }
          ]
        },
        {
          name: 'Pedidos de Compra',
          route: '/purchase-orders',
          children: [
            {
              name: 'Lista de Pedidos',
              route: '/purchase-orders'
            },
            {
              name: 'Novo Pedido',
              route: '/purchase-orders/new'
            }
          ]
        }
      ]
    },

    {
      name: 'Controladoria',
      icon: 'fa-solid fa-landmark',
      route: '/financial/cost-centers',
      groupId: ModuleGroup.Controladoria,
      children: [
        {
          name: 'Centros de Custo',
          route: '/financial/cost-centers',
          children: [
            {
              name: 'Lista de Centros de Custo',
              route: '/financial/cost-centers'
            },
            {
              name: 'Novo Centro de Custo',
              route: '/financial/cost-centers/new'
            }
          ]
        },
        {
          name: 'Propostas de orçamento',
          route: '/financial/budget-proposals'
        }
      ]
    },
    {
      name: 'Financeiro',
      icon: 'fa-solid fa-chart-pie',
      route: '/',
      groupId: ModuleGroup.Financeiro,
      children: [
        {
          name: 'Contas a Pagar',
          route: '/financial/accounts-payable',
          children: [
            {
              name: 'Lista de Contas a Pagar',
              route: '/financial/accounts-payable'
            },
            {
              name: 'Nova Conta a Pagar',
              route: '/financial/accounts-payable/new'
            }
          ]
        },
        {
          name: 'Contas a Receber',
          route: '/financial/accounts-receivable',
          children: [
            {
              name: 'Lista de Contas a Receber',
              route: '/financial/accounts-receivable'
            },
            {
              name: 'Nova Conta a Receber',
              route: '/financial/accounts-receivable/new'
            }
          ]
        },
        {
          name: 'IPVA e Licenciamento',
          route: '/financial/ipva-licensing'
        },
        {
          name: 'Acordos',
          route: '/financial/agreements'
        },
        // {
        //   name: 'Bancário',
        //   route: '/financial/bank-statements',
        //   children: [
        //     { name: 'Extratos Bancários', route: '/financial/bank-statements' },
        //     { name: 'Transações Bancárias', route: '/financial/bank-transactions' },
        //     { name: 'Operadora de Cartões', route: '/financial/card-operator' }
        //   ]
        // },
        {
          name: 'Espelho financeiro',
          route: '/financial/cashflow'
        },
        {
          name: 'Relatórios financeiros',
          route: '/financial/reports',
          children: [
            { name: 'Catálogo', route: '/financial/reports' },
            { name: 'Posição contas a pagar', route: '/financial/reports/ap-position' }
          ]
        },
      ]
    },
    {
      name: 'Documentos',
      icon: 'fa-solid fa-file-contract',
      route: '/documents/templates',
      groupId: ModuleGroup.Documentos,
      children: [
        {
          name: 'Templates',
          route: '/documents/templates'
        }
      ]
    },
    {
      name: 'Produtos',
      icon: 'fa-solid fa-box',
      route: '/products',
      groupId: ModuleGroup.Produtos,
      children: [
        {
          name: 'Lista de Produtos',
          route: '/products'
        },
        {
          name: 'Novo Produto',
          route: '/products/new'
        }
      ]
    },
    {
      name: 'Estoque',
      icon: 'fa-solid fa-boxes-stacked',
      route: '/',
      groupId: ModuleGroup.Estoque,
      children: [
        {
          name: 'Almoxarifados',
          route: '/stock/warehouses',
          children: [
            {
              name: 'Lista de Almoxarifados',
              route: '/stock/warehouses'
            },
            {
              name: 'Novo Almoxarifado',
              route: '/stock/warehouses/new'
            }
          ]
        },
        {
          name: 'Estoque',
          route: '/stock/inventory',
          children: [
            {
              name: 'Lista de Estoque',
              route: '/stock/inventory'
            },
            {
              name: 'Novo Estoque',
              route: '/stock/inventory/new'
            }
          ]
        },
        {
          name: 'Itens',
          route: '/stock/items',
          children: [
            {
              name: 'Lista de Itens',
              route: '/stock/items'
            },
            {
              name: 'Novo Item',
              route: '/stock/items/new'
            }
          ]
        },
        {
          name: 'Movimentações',
          route: '/stock/movements',
          children: [
            {
              name: 'Entrada/Saída de Produtos',
              route: '/stock/movements'
            },
            {
              name: 'Todas as movimentações',
              route: '/stock/movements/todas'
            }
          ]
        },
        {
          name: 'Solicitações de OS',
          route: '/stock/requests'
        },
        {
          name: 'Alertas',
          route: '/stock/alerts'
        },
        {
          name: 'Aprovações',
          route: '/stock/approvals'
        }
      ]
    },
    {
      name: 'Operações',
      icon: 'fa-solid fa-gears',
      route: '/',
      groupId: ModuleGroup.Operacoes,
      children: [
        {
          name: 'Checklist',
          route: '/checklist'
        },
        {
          name: 'Mecânico',
          route: '/mechanic'
        },
        {
          name: 'Suporte',
          route: '/support'
        },
        {
          name: 'Preventiva',
          route: '/operations/preventive-maintenance',
          children: [
            {
              name: 'Lista de Preventivas',
              route: '/operations/preventive-maintenance'
            },
            {
              name: 'Histórico de Preventivas',
              route: '/operations/preventive-maintenance/history'
            }
          ]
        },
        {
          name: 'Tipos de Serviços',
          route: '/operations/services',
          children: [
            {
              name: 'Lista de Serviços',
              route: '/operations/services'
            },
            {
              name: 'Novo Serviço',
              route: '/operations/services/new'
            }
          ]
        }
      ]
    },
    {
      name: 'B2B',
      icon: 'fa-solid fa-people-arrows',
      route: '/b2b/contracts',
      groupId: ModuleGroup.B2B,
      children: [
        {
          name: 'Dashboard',
          route: '/b2b/contracts/dashboard'
        },
        {
          name: 'Contratos',
          route: '/b2b/contracts',
          children: [
            {
              name: 'Lista de Contratos',
              route: '/b2b/contracts'
            },
            {
              name: 'Novo Contrato',
              route: '/b2b/contracts/new'
            }
          ]
        },
        {
          name: 'Usuários do portal',
          route: '/b2b/portal-users'
        },
        {
          name: 'Agendamentos',
          route: '/b2b/appointments'
        },
        {
          name: 'Prestadores Externos',
          route: '/b2b/external-service-providers',
          children: [
            {
              name: 'Lista de Prestadores',
              route: '/b2b/external-service-providers'
            },
            {
              name: 'Novo Prestador',
              route: '/b2b/external-service-providers/new'
            }
          ]
        },
        {
          name: 'Orç. Serviços',
          route: '/b2b/budget-service-orders'
        },
        {
          name: 'Fechamento B2B',
          route: '/b2b/billing-closing'
        }
      ]
    },
    {
      name: 'Administrativo',
      icon: 'fa-solid fa-user-shield',
      route: '/',
      groupId: ModuleGroup.Administrativo,
      children: [
        {
          name: 'Usuários',
          route: '/users',
          children: [
            {
              name: 'Lista de Usuários',
              route: '/users'
            },
            {
              name: 'Cadastro de Usuários',
              route: '/users/new'
            }
          ]
        },
        {
          name: 'Grupos',
          route: '/admin/groups',
          children: [
            {
              name: 'Lista de Grupos',
              route: '/admin/groups'
            },
            {
              name: 'Novo Grupo',
              route: '/admin/groups/new'
            }
          ]
        },
        {
          name: 'Perfis',
          route: '/admin/profiles',
          children: [
            {
              name: 'Lista de Perfis',
              route: '/admin/profiles'
            },
            {
              name: 'Novo Perfil',
              route: '/admin/profiles/new'
            }
          ]
        },
        {
          name: 'Agenda',
          route: '/admin/schedule'
        },
        {
          name: 'Agendamentos',
          route: '/appointments'
        }
      ]
    },
    {
      name: 'Ordem de Serviços',
      icon: 'fa-solid fa-clipboard-list',
      route: '/',
      groupId: ModuleGroup.OrdemServico,
      children: [
        {
          name: 'Lista de OS',
          route: '/service-orders'
        },
        {
          name: 'Consulta',
          route: '/service-orders/consulta'
        },
        {
          name: 'Nova OS',
          route: '/service-orders/new'
        },
        {
          name: 'Pedidos (Não OS)',
          route: '/purchase-orders'
        },
        {
          name: 'Config. OS',
          route: '/service-orders/config'
        }
      ]
    },
    {
      name: 'Configurações',
      icon: 'fa-solid fa-cog',
      route: '/',
      groupId: ModuleGroup.Configuracoes,
      children: [
        {
          name: 'Gestão de Status',
          route: '/config/status'
        },
        {
          name: 'Bloqueio do Sistema',
          route: '/config/system-lock'
        }
      ]
    },
  ];

  @ViewChild('sidebarContent', { static: false }) sidebarContent!: ElementRef;

  currentUser: User | null = null;
  sidebarOpen: boolean = false;
  activeSubmenuIndex: number | null = null;
  activeNestedSubmenus: { [key: string]: boolean } = {};
  currentRoute: string = '';
  showScrollToBottomButton: boolean = false;
  private groupsSubscription?: Subscription;
  private routeSubscription?: Subscription;
  private resizeHandler = () => this.checkScreenSize();
  private scrollHandler = () => this.checkScrollPosition();

  constructor(
    public router: Router,
    private authService: AuthService,
    private usersService: UsersService,
    private permissionService: PermissionService,
    private notificationsService: NotificationsService
  ) { }

  /**
   * Retorna os itens do menu filtrados pelas permissões do usuário
   */
  get filteredMenuItems(): ItensMenus[] {
    return this.itensMenus.filter(item => {
      // Se o item não tem groupId definido, é visível para todos (como Home)
      if (!item.groupId) {
        return true;
      }
      // Verifica se o usuário tem permissão para este grupo
      return this.permissionService.hasGroup(item.groupId);
    });
  }

  ngOnInit(): void {
    this.currentUser = this.authService.currentUserValue;

    // Carregar nome do usuário do token
    this.currentUserName = this.authService.getUserNameFromToken() || 'Usuário';

    // Carregar avatar do usuário
    this.loadUserAvatar();

    // Carregar notificações
    this.loadNotifications();

    // Subscrever às mudanças de grupos para atualizar o menu automaticamente
    this.groupsSubscription = this.permissionService.userGroups$.subscribe(groups => {
      // O getter filteredMenuItems será automaticamente reavaliado
    });

    // Check if sidebar should be open by default on larger screens
    this.checkScreenSize();

    // Listen for window resize
    window.addEventListener('resize', this.resizeHandler);

    // Listen for route changes to update current route
    this.routeSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.urlAfterRedirects || event.url;
        // Keep sidebar anchored for checklist routes
        if (this.currentRoute.startsWith('/checklist') || this.currentRoute.startsWith('/hr/payroll')) {
          this.sidebarOpen = true;
        }
        this.autoOpenRelevantSubmenus();
      }
    });

    // Initialize with current route
    this.currentRoute = this.router.url;
    this.autoOpenRelevantSubmenus();
  }

  /**
   * Automatically opens relevant submenus based on current route
   */
  private autoOpenRelevantSubmenus(): void {
    if (!this.currentRoute) return;
    this.syncMenuStateWithRoute(this.currentRoute);
  }

  /**
   * Checks if a route is contained within a menu item or its children
   */
  private isRouteInMenu(menuItem: ItensMenus | SubItensMenus, route: string): boolean {
    if (this.routeMatches(menuItem.route, route)) return true;

    if (menuItem.children) {
      return menuItem.children.some(child => {
        if (this.routeMatches(child.route, route)) return true;

        if (child.children) {
          return child.children.some(nestedChild => this.routeMatches(nestedChild.route, route));
        }

        return false;
      });
    }

    return false;
  }

  /**
   * Checks if a menu item should be highlighted as active
   */
  isMenuItemActive(menuItem: ItensMenus): boolean {
    return this.isRouteInMenu(menuItem, this.currentRoute);
  }

  /**
   * Checks if a submenu item should be highlighted as active
   */
  isSubmenuItemActive(menuItem: ItensMenus, subItem: any): boolean {
    return this.routeMatches(subItem.route, this.currentRoute);
  }

  /**
   * Checks if a nested submenu item should be highlighted as active
   */
  isNestedSubmenuItemActive(menuItem: ItensMenus, subItem: any, nestedItem: any): boolean {
    return this.routeMatches(nestedItem.route, this.currentRoute);
  }

  toggleSidebar(): void {
    this.sidebarOpen = !this.sidebarOpen;
    // Verifica a posição do scroll quando o sidebar é aberto
    setTimeout(() => {
      this.checkScrollPosition();
    }, 100);
  }

  closeSidebar(): void {
    this.sidebarOpen = false;
  }

  onMainMenuClick(item: ItensMenus, index: number, event: MouseEvent): void {
    event.preventDefault();
    const hasChildren = !!item.children && item.children.length > 0;
    const hasNavigableRoute = !!item.route && item.route !== '/';

    // Quando houver rota real, navega direto e mantém submenu aberto.
    if (hasNavigableRoute) {
      this.navigateTo(item.route);
      if (hasChildren) {
        this.activeSubmenuIndex = index;
      }
      return;
    }

    // Itens de agrupamento sem rota (route: '/'): apenas abre/fecha submenu.
    if (hasChildren) {
      this.toggleSubmenu(index);
    }
  }

  /**
   * Toggle submenu - controle manual completo
   */
  toggleSubmenu(index: number): void {
    if (this.activeSubmenuIndex === index) {
      this.activeSubmenuIndex = null;
    } else {
      this.activeSubmenuIndex = index;
    }
    // Verifica a posição do scroll após mudança no submenu
    setTimeout(() => {
      this.checkScrollPosition();
    }, 0);
  }

  /**
   * Check if submenu should be shown
   */
  shouldShowSubmenu(index: number): boolean {
    return this.activeSubmenuIndex === index;
  }

  closeSubmenu(): void {
    this.activeSubmenuIndex = null;
    this.activeNestedSubmenus = {};
  }

  /**
   * Toggle nested submenu - controle manual completo
   */
  toggleNestedSubmenu(parentIndex: number, childIndex: number): void {
    const key = `${parentIndex}-${childIndex}`;

    if (this.activeNestedSubmenus[key]) {
      // Fechar submenu aninhado
      this.activeNestedSubmenus[key] = false;
    } else {
      // Abrir submenu aninhado
      this.activeNestedSubmenus[key] = true;
    }
    // Verifica a posição do scroll após mudança no submenu aninhado
    setTimeout(() => {
      this.checkScrollPosition();
    }, 0);
  }

  isNestedSubmenuOpen(parentIndex: number, childIndex: number): boolean {
    const key = `${parentIndex}-${childIndex}`;
    return !!this.activeNestedSubmenus[key];
  }

  /**
   * Fechar todos os submenus aninhados
   */
  closeAllNestedSubmenus(): void {
    this.activeNestedSubmenus = {};
  }

  /**
   * Fechar um submenu aninhado específico
   */
  closeNestedSubmenu(parentIndex: number, childIndex: number): void {
    const key = `${parentIndex}-${childIndex}`;
    this.activeNestedSubmenus[key] = false;
  }

  private normalizeRoute(route: string): string {
    return String(route || '').split('?')[0].split('#')[0];
  }

  /**
   * Considera rota ativa quando:
   * - é exatamente igual, ou
   * - a rota atual é filha da rota-base (ex.: /ranges/1/edit -> /ranges)
   */
  private routeMatches(targetRoute: string, currentRoute: string): boolean {
    const target = this.normalizeRoute(targetRoute);
    const current = this.normalizeRoute(currentRoute);
    if (!target || !current) return false;
    if (target === current) return true;
    return current.startsWith(`${target}/`);
  }

  private checkScreenSize(): void {
    // Auto-open sidebar on desktop screens
    if (window.innerWidth >= 992) {
      this.sidebarOpen = true;
    } else {
      this.sidebarOpen = false;
    }
  }

  /**
   * Mantém o estado do menu previsível com base na rota atual.
   * Evita "piscar" e reset indevido de submenu ao navegar.
   */
  private syncMenuStateWithRoute(route: string): void {
    let matchedMainIndex: number | null = null;
    const nextNested: { [key: string]: boolean } = {};

    this.filteredMenuItems.forEach((item, index) => {
      if (!this.isRouteInMenu(item, route)) {
        return;
      }
      // Primeiro match vence para manter comportamento estável.
      if (matchedMainIndex === null) {
        matchedMainIndex = index;
      }

      if (item.children) {
        item.children.forEach((child, childIndex) => {
          if (this.isRouteInMenu(child, route)) {
            nextNested[`${index}-${childIndex}`] = true;
          }
        });
      }
    });

    this.activeSubmenuIndex = matchedMainIndex;
    this.activeNestedSubmenus = nextNested;
  }

  /**
   * Navigate to route without closing submenus
   */
  navigateTo(route: string, queryParams?: { [key: string]: any }): void {
    this.router.navigate([route], queryParams ? { queryParams } : {});

    // Don't close submenus on desktop, only on mobile
    if (window.innerWidth < 992) {
      // Manter sidebar ancorado em rotas específicas (checklist, central de salários)
      const shouldKeepOpen =
        route.startsWith('/checklist') ||
        route.startsWith('/hr/payroll');

      if (!shouldKeepOpen) {
        this.closeSidebar();
      } else {
        this.sidebarOpen = true;
      }
    }
    // IMPORTANTE: NÃO fechar os submenus quando navegar!
    // Eles devem permanecer abertos e fixos
  }

  logout(): void {
    // Optional: Add confirmation dialog
    if (confirm('Tem certeza que deseja sair?')) {
      // Limpa o avatar do localStorage
      if (this.currentUser?.userId) {
        localStorage.removeItem(`user_avatar_${this.currentUser.userId}`);
      }

      // Limpar permissões
      this.permissionService.clearUserGroups();

      this.authService.logout();
      this.router.navigate(['/login']);
    }
  }

  navigateToProfile(): void {
    this.router.navigate(['/profile']);
  }

  ngAfterViewInit(): void {
    // Configura o listener de scroll após a view ser inicializada
    if (this.sidebarContent) {
      this.sidebarContent.nativeElement.addEventListener('scroll', this.scrollHandler);
    }
  }

  /**
   * Verifica a posição do scroll para mostrar/esconder o botão
   */
  checkScrollPosition(): void {
    if (!this.sidebarContent) return;

    const element = this.sidebarContent.nativeElement;
    const scrollTop = element.scrollTop;
    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;

    // Mostra o botão se não estiver no final da lista (com margem de 50px)
    this.showScrollToBottomButton = (scrollTop + clientHeight) < (scrollHeight - 50);
  }

  /**
   * Rola para o último item do menu
   */
  scrollToBottom(): void {
    if (!this.sidebarContent) return;

    const element = this.sidebarContent.nativeElement;
    element.scrollTo({
      top: element.scrollHeight,
      behavior: 'smooth'
    });
  }

  /**
   * Carrega o avatar do usuário
   * Verifica primeiro no localStorage para evitar requisições desnecessárias
   */
  loadUserAvatar(): void {
    if (!this.currentUser?.userId) return;

    // Verifica se o avatar já está no localStorage
    const cachedAvatar = localStorage.getItem(`user_avatar_${this.currentUser.userId}`);

    if (cachedAvatar) {
      // Usa o avatar do cache
      this.userAvatar = cachedAvatar;
      return;
    }

    // Se não estiver em cache, busca do serviço
    this.usersService.getAvatar(this.currentUser.userId).subscribe({
      next: (response) => {
        if (response?.avatar) {
          // Verifica se o base64 já tem o prefixo data:image
          if (response.avatar.startsWith('data:image')) {
            this.userAvatar = response.avatar;
          } else {
            // Adiciona o prefixo para imagens PNG por padrão
            this.userAvatar = `data:image/png;base64,${response.avatar}`;
          }

          // Armazena no localStorage para uso futuro
          if (this.userAvatar && this.currentUser?.userId) {
            localStorage.setItem(`user_avatar_${this.currentUser.userId}`, this.userAvatar);
          }
        }
      },
      error: (err) => {
        // Não loga quando for CORS (status 0) ou 404 (endpoint não existe no backend local)
        const status = err?.status;
        if (status !== 0 && status !== 404) {
          console.error('Erro ao carregar avatar:', err);
        }
        this.userAvatar = null;
      }
    });
  }

  ngOnDestroy(): void {
    // Cleanup de listeners e subscriptions
    window.removeEventListener('resize', this.resizeHandler);

    if (this.sidebarContent) {
      this.sidebarContent.nativeElement.removeEventListener('scroll', this.scrollHandler);
    }
    // Desinscrever do observable de grupos
    if (this.groupsSubscription) {
      this.groupsSubscription.unsubscribe();
    }

    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  /**
   * Toggle do modal de notificações
   */
  toggleNotifications(): void {
    this.showNotifications = !this.showNotifications;
  }

  /**
   * Fecha o modal de notificações ao clicar fora
   */
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const notificationWrapper = target.closest('.notification-wrapper');

    if (!notificationWrapper && this.showNotifications) {
      this.showNotifications = false;
    }
  }

  /**
   * Marca uma notificação como lida
   */
  toggleReadStatus(notification: Notification): void {
    if (notification.read) return;

    const userId = this.currentUser?.userId?.toString() || '';
    this.notificationsService.markAsRead(notification.id, userId).subscribe({
      next: () => {
        notification.read = true;
        this.updateUnreadCount();
      },
      error: (err) => {
        console.error('Erro ao marcar notificação como lida:', err);
      }
    });
  }

  /**
   * Marca todas as notificações como lidas
   */
  markAllAsRead(): void {
    if (!this.currentUser?.userId) return;

    const userId = this.currentUser.userId;
    const updatedBy = userId.toString();

    this.notificationsService.markAllAsRead(userId, updatedBy).subscribe({
      next: () => {
        this.notifications.forEach(n => n.read = true);
        this.updateUnreadCount();
      },
      error: (err) => {
        console.error('Erro ao marcar todas as notificações como lidas:', err);
      }
    });
  }

  /**
   * Exclui uma notificação
   */
  deleteNotification(id: number): void {
    const deletedBy = this.currentUser?.userId?.toString() || '';

    this.notificationsService.delete(id, deletedBy).subscribe({
      next: () => {
        this.notifications = this.notifications.filter(n => n.id !== id);
        this.updateUnreadCount();
      },
      error: (err) => {
        console.error('Erro ao excluir notificação:', err);
      }
    });
  }

  /**
   * Atualiza o contador de notificações não lidas via API
   */
  private updateUnreadCount(): void {
    if (!this.currentUser?.userId) {
      this.unreadNotificationsCount = this.notifications.filter(n => !n.read).length;
      return;
    }

    this.notificationsService.getUnreadCount(this.currentUser.userId).subscribe({
      next: (response) => {
        this.unreadNotificationsCount = response.unreadCount;
      },
      error: () => {
        // Fallback: contagem local
        this.unreadNotificationsCount = this.notifications.filter(n => !n.read).length;
      }
    });
  }

  /**
   * Carrega notificações do usuário via API
   */
  private loadNotifications(): void {
    if (!this.currentUser?.userId) return;

    this.notificationsService.getByUserId(this.currentUser.userId).subscribe({
      next: (response) => {
        this.notifications = response.data;
        this.updateUnreadCount();
      },
      error: (err) => {
        // Não loga quando for CORS (status 0) ou 404 (endpoint não existe no backend local)
        const status = err?.status;
        if (status !== 0 && status !== 404) {
          console.error('Erro ao carregar notificações:', err);
        }
        this.notifications = [];
        this.unreadNotificationsCount = 0;
      }
    });
  }
}
